import { StepWizardStep } from '../../../commons/StepWizard/StepWizard.types';
import LoginPUBForm from './LoginPUBForm/LoginPUBForm';

export const loginCommercialSteps: StepWizardStep[] = [
  {
    step: 1,
    component: LoginPUBForm,
    title: 'Connexion <primary>acheteurs publics</primary>',
    subtitle: 'Entrez vos identifiants',
  },
];
